<template>
  <section>
    <form method="POST" action="authenticate" @submit.prevent.stop="auth">

      <img :src="baseURL+'img/logo.png'" alt="Sofca">
      <h1>J'accède à mon relevé kilométrique</h1>

      <fieldset>
        <input
          type="text"
          name="authenticate[npo]"
          v-model="npo"
          required
          placeholder="N° de contrat du véhicule"
          :autofocus="npo === ''">

        <button type="button" @click.prevent="showInfo = true" tabindex="-1">
          <img :src="baseURL+'img/info_blue.png'" alt="">
        </button>
        <Modal :visible="showInfo" @close="showInfo = false">
          <strong>Où trouver mon numéro de contrat ?</strong>
          <small>Le numéro de contrat est renseigné sur le contrat et l’appel de cotisation.</small>
        </Modal>
      </fieldset>

      <fieldset>
        <input
          type="text"
          name="authenticate[registration]"
          v-model="registration"
          required
          placeholder="N° de plaque d'immatriculation"
          :autofocus="npo !== ''">
      </fieldset>

      <button type="submit" v-if="loading" disabled>Chargement...</button>
      <button type="submit" v-else>Me connecter</button>

      <Modal :visible="showError" @close="showError = false">
        <strong>Erreur d'identification</strong>
        <small>Le numéro de contrat et/ou le numéro de plaque d'immatriculation sont inconnus.</small>
      </Modal>

      <small class="info">
        <img :src="baseURL+'img/info_white.png'" alt="">
        L‘authentification doit être réalisée par le souscripteur du contrat auto au kilomètre, pour le véhicule concerné par le relevé kilométrique.
      </small>
      <small class="help auth">
        <a href="https://www.allianz.fr/assurance-auto/mon-releve-kilometrique" target="_blank">Une question, un problème ? Cliquez ici</a>
      </small>
    </form>
  </section>
</template>

<script>
  import Modal from '@/components/Modal'

  export default {
    components: {
      Modal
    },
    data() {
      return {
        baseURL: process.env.BASE_URL,
        loading: false,
        showInfo: false,
        npo: this.$route.query.npo || '',
        registration: '',
        showError: false,
        error: ''
      }
    },
    methods: {
      async auth(e) {
        this.$data.loading = true
        const error = await this.$store.dispatch('login', {
          url: e.target.attributes.action.value,
          npo: this.$data.npo,
          registration: this.$data.registration
        })
        this.$data.loading = false
        if(error) {
          this.$data.showError = true
        } else {
          this.$router.push({name: 'photos'})
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background: url(../../public/img/auth_bg.jpg) no-repeat center;
    background-size: cover;

    // Center vertically
    &:before {
      content: '';
      flex: .5;
    }
  }

  form {
    max-width: 25rem;
    margin-left: auto;
    margin-right: auto;
    padding: spacer(2) spacer();
  }

  h1 {
    font-weight: 500;
    text-align: center;
    font-size: 1.5em;
    line-height: 1.2;
    color: color('secondaryBlue');
    margin-top: spacer(2);
    margin-bottom: spacer(2);
  }

  fieldset {
    appearance: none;
    border: none;
    padding: 0;
    margin: 0;
    background: none;
    position: relative;

    & + & {
      border-top: 1px solid mix(black,white,10);
    }
  }

  [type="text"],
  [type="submit"] {
    appearance: none;
    border: none;
    width: 100%;
    border-radius: 0;
    padding: spacer() spacer(1.5) spacer(.9);
    position: relative;

    &:focus {
      z-index: 1;
    }
  }

  [type="text"] {
    background: white;
    color: inherit;

    &::placeholder {
      color: rgba(black,.4);
    }
  }

  [type="submit"] {
    background-color: color('secondaryBlue');
    color: white;
    text-transform: uppercase;
    margin-top: spacer(2);

    &[disabled] {
      opacity: .5;
    }
  }

  [type="button"] {
    width: 1.1em;
    height: 1.1em;
    appearance: none;
    border: none;
    background: none;
    padding: 0;
    position: absolute;
    right: spacer(1.5);
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    &:before {
      content: '';
      width: 44px;
      height: 44px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }

  .info {
    display: block;
    font-size: 1em;
    color: white;
    margin-top: spacer(2);
    padding-left: 1.5em;
    position: relative;

    img {
      width: 1.1em;
      height: 1.1em;
      position: absolute;
      left: 0;
    }
  }

  .help {
    &.auth {
      text-align: center;
      width: 100%;
      display: block;
      margin-top: 80px;

      a {
        color: #fff;
        font-size: 1.3em;
        text-decoration: none;
        font-weight: lighter;
      }
    }
  }
</style>
